module.exports = __webpack_public_path__ + "img/bg5.534ce69a.jpg";